import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import './styles/animations.css';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import LeadershipHome from './pages/LeadershipHome';
import Home from './pages/Home';
import Products from './pages/Products';
import TrainingList from './pages/TrainingList';
import TrainingDetail from './pages/TrainingDetail';
import TrainingGuide from './pages/TrainingGuide';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LeadershipHome />} />
            <Route path="/home" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/training" element={<TrainingList />} />
            <Route path="/training/:slug" element={<TrainingDetail />} />
            <Route path="/training/:slug/guide" element={<TrainingGuide />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;